<template>
  <div class="expressFormComponent-wrap">
    <ul class="express-form">
      <li>
        <label>快递单号</label>
        <input
          id="expressIdIpt"
          v-model="expressId"
          @blur="expressIdBlur"
          @click="iptFocus"
          class="ipt"
          type="text"
          placeholder="请填写快递单号"
        />
        <span class="scan-btn" @click="scanExpressNum"></span>
      </li>
      <li>
        <label>快递公司</label>
        <span class="expressCompanyBox" @click="expressPopupToggle(true)">
          <input
            :value="expressCompanyDesc"
            @focus="iptFocus"
            disabled
            class="ipt"
            type="text"
            placeholder="请选择快递公司"
          />
          <span class="right-row"></span>
        </span>
      </li>
      <li>
        <label>联系人</label>
        <input
          v-model="consignee"
          @blur="iptBlur"
          @focus="iptFocus"
          class="ipt"
          type="text"
          placeholder="请输入联系人姓名"
        />
      </li>
      <li>
        <label>手机号</label>
        <input
          v-model="consigneePhone"
          @blur="iptBlur"
          @focus="iptFocus"
          class="ipt"
          type="text"
          placeholder="请输入手机号码"
        />
      </li>
    </ul>
    <div>
      <div
        :class="[
          'izk-popup izk-popup-bottom',
          expressPopupShow ? 'izk-popup-show' : 'izk-popup-hide',
        ]"
      >
        <h5 class="izk-popup-title">
          请选择快递公司<i
            class="close-icon"
            @click="expressPopupToggle(false)"
          ></i>
        </h5>
        <div class="izk-popup-content">
          <ul class="express-list">
            <template v-if="expressCompanyList.length > 0">
              <li
                v-for="item in expressCompanyList"
                @click="selectExpressCompany(item)"
                :class="{ selected: expressCompany == item.id }"
                :key="item.id"
              >
                <label>{{ item.name }}</label>
                <i v-if="expressCompany == item.id" class="success-icon"></i>
              </li>
            </template>
          </ul>
        </div>
      </div>
      <div
        :class="[
          'izk-overlay',
          expressPopupShow ? 'izk-overlay-show' : 'izk-overlay-hide',
        ]"
        @click="expressPopupToggle(false)"
      ></div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "expressFormComponent",
  data() {
    return {
      expressId: "", //快递单号
      expressCompanyDesc: "",
      expressCompany: "",
      consignee: "",
      consigneePhone: "",
      expressPopupShow: false,
      expressCompanyList: [],
      iptFocusScrollTop: "",
      iptBlurTimeOut: "",
    };
  },
  props: {
    bizId: {
      type: String || Number,
    },
  },
  mounted() {
    // window.returnH5ExpressCodeNumer = this.returnH5ExpressCode;
    if (window._dhbridge) {
      window.dhsdk.onListenEvent(
        "returnH5ExpressCodeNumer",
        this.returnH5ExpressCode
      );
    }
    //快递信息弹框列表
    this.getExpressCompanyList();
    if (this.bizId) {
      //编辑快递信息信息回填
      this.getExpressInfo();
    } else {
      this.getStuInfo();
    }
    window.scrollTo(0, 0);
  },
  methods: {
    ...mapMutations({
      changeLoading: "changeLoading",
    }),
    //客户端调用此方法，返回运单号
    returnH5ExpressCode: function (data) {
      this.expressId = data.data.express_num || "";
      this.getExpressCompanyByCode();
    },
    //快递单号失去焦点时
    expressIdBlur() {
      this.iptBlur();
      if (!this.expressId.trim()) {
        return;
      }
      this.getExpressCompanyByCode();
    },
    //根据单号查快递公司
    getExpressCompanyByCode() {
      if (!/^[a-zA-Z0-9]+$/.test(this.expressId.trim())) {
        return;
      }
      this.changeLoading(true);
      this.$api.my
        .getExpressCompanyByCode({
          expressId: this.expressId.trim(),
        })
        .then((res) => {
          this.changeLoading(false);
          if (res.ret) {
            this.expressCompany = res.data.id || "";
            this.expressCompanyDesc = res.data.name || "";
          } else {
            this.expressCompany = "";
            this.expressCompanyDesc = "";
            this.$toast(res.msg);
          }
        });
    },
    //输入框blur-兼容iPhone6sp调起键盘后，点击提交按钮时无效，需发生滚动 500 自定义键盘收起时间
    iptBlur() {
      let iptBlurTimeOut = setTimeout(() => {
        if (this.iptFocusScrollTop) {
          window.scrollTo(0, this.iptFocusScrollTop);
        } else {
          window.scrollTo(0, 0);
        }
      }, 250);
      this.iptBlurTimeOut = iptBlurTimeOut;
    },
    //输入框focus-兼容iPhone6sp调起键盘后，点击提交按钮时无效，需发生滚动
    iptFocus(e) {
      clearTimeout(this.iptBlurTimeOut);
      let iptFocusScrollTop =
        document.documentElement.scrollTop ||
        window.pageYOfset ||
        document.body.scrollTop;
      this.iptFocusScrollTop = iptFocusScrollTop;

      e.target.scrollIntoView({ behavior: "smooth", block: "end" });
    },
    //扫码
    scanExpressNum() {
      window.dhsdk.getExpressCodeNumer({
        success: () => {},
        fail: () => {},
      });
    },
    //快递列表显示\隐藏
    expressPopupToggle(showValue) {
      this.expressPopupShow = showValue;
    },
    //快递公司列表选择
    selectExpressCompany(obj) {
      this.expressCompany = obj.id;
      this.expressCompanyDesc = obj.name;

      this.expressPopupToggle(false);
    },
    //获取快递公司列表
    getExpressCompanyList() {
      return new Promise((resolve) => {
        this.$api.my.getExpressCompanyList({}).then((res) => {
          if (res.ret) {
            this.expressCompanyList = res.data;

            resolve(res.data);
          } else {
            this.$toast(res.msg);
          }
        });
      });
    },
    //编辑-获取快递信息
    getExpressInfo() {
      this.changeLoading(true);
      this.$api.my
        .getReturnInfoDetail({
          mrbNum: this.bizId,
        })
        .then((res) => {
          this.changeLoading(false);
          if (res.ret) {
            this.expressId = res.data.expressId;
            this.expressCompanyDesc = res.data.expressCompanyDesc;
            this.expressCompany = res.data.expressCompany;
            this.consignee = res.data.consignee;
            this.consigneePhone = res.data.consigneePhone;
          } else {
            this.$toast(res.msg);
          }
        });
    },
    //新增-获取联系人、手机号
    getStuInfo() {
      this.changeLoading(true);
      this.$api.my.getStudentInfo().then((res) => {
        this.changeLoading(false);
        if (res.ret) {
          this.consignee = res.data.name;
          this.consigneePhone = res.data.phone;
        } else {
          this.$toast(res.msg);
        }
      });
    },
    //必填项校验
    formValidator() {
      if (!this.expressId.trim()) {
        this.$toast("请输入快递单号");
        return false;
      } else if (!/^[a-zA-Z0-9]+$/.test(this.expressId.trim())) {
        this.$toast("快递单号只支持字母或数字");
        return false;
      } else if (this.expressId.trim().length > 50) {
        this.$toast("快递单号最多支持50个字符");
        return false;
      }
      if (!this.expressCompanyDesc.trim()) {
        this.$toast("请选择快递公司");
        return false;
      }
      if (!this.consignee.trim()) {
        this.$toast("请填写联系人姓名");
        return false;
      } else if (!/^[\u4e00-\u9fa5\s]{2,7}$/.test(this.consignee)) {
        this.$toast("联系人只支持2-7个汉字");
        return false;
      }
      if (!this.consigneePhone.trim()) {
        this.$toast("请填写手机号");
        return false;
      } else {
        var regphone =
          /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/;
        if (!regphone.test(this.consigneePhone.trim())) {
          this.$toast("手机号码填写错误");
          return false;
        }
      }
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.expressFormComponent-wrap {
  .express-form {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 14px;
    li {
      border-bottom: 1px solid rgba(242, 242, 242, 1);
      display: flex;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      align-items: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      padding: 14px 0;
      position: relative;
      label {
        width: 85px;
        color: rgba(102, 102, 102, 1);
        padding-top: 1px;
      }
      input.ipt {
        height: 30px;
        flex: 1;
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -ms-flex: 1;
        caret-color: #cd0014;
        line-height: 25px;
        margin-right: 25px;
      }
      @supports (-webkit-mask: none) and (not (caret-color: blue)) {
        .input.ipt {
          color: #cd0014;
        }
        .input.ipt::first-line {
          color: rgba(51, 51, 51, 1);
        }
      }
      input:disabled {
        background-color: #ffffff;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        -webkit-text-fill-color: rgba(51, 51, 51, 1); //字体颜色安卓与IOS适配
        -webkit-opacity: 1; //不透明级别安卓与IOS适配
      }
      .scan-btn,
      .right-row {
        position: absolute;
        right: 0;
        top: 18px;
      }
    }
    li:last-of-type {
      border-bottom: none;
    }
    .expressCompanyBox {
      flex: 1;
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -ms-flex: 1;
      display: flex;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      align-items: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
    }
  }
  .izk-popup {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 15px;
    border-radius: 10px 10px 0rem 0rem;
    background: rgba(255, 255, 255, 1);
    z-index: 2000;
    &-title {
      background: rgba(255, 255, 255, 1);
      border-bottom: 1px solid rgba(240, 240, 240, 1);
      text-align: center;
      font-size: 18px;
      padding: 21px 20px 0;
      border-radius: 10px 10px 0rem 0rem;
      position: absolute;
      width: 100%;
      height: 54px;
      .close-icon {
        float: right;
        position: relative;
        top: -5px;
      }
    }
    &-content {
      min-height: 150px;
      max-height: 450px;
      overflow-y: scroll;
      padding-top: 55px;
    }
    &-show {
      opacity: 1;
      transform: translateY(0);
      transition: all 0.2s ease-in;
    }
    &-hide {
      opacity: 0;
      transform: translateY(100%);
      transition: all 0.2s ease-in;
    }
  }
  .close-icon {
    display: inline-block;
    width: 22px;
    height: 22px;
    background: url("../../../assets/img/myPackage/close_grey_icon@2x.png")
      no-repeat 0 0;
    background-size: cover;
  }
  .izk-popup-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding-bottom: 25px;
  }
  .izk-overlay {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    &-show {
      display: block;
    }
    &-hide {
      display: none;
    }
  }
  .express-list {
    li {
      display: flex;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      align-items: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      justify-content: space-between;
      -webkit-box-pack: space-between;
      -webkit-justify-content: space-between;
      -ms-flex-pack: space-between;
      padding: 15px 20px;
    }
    li.selected {
      color: rgba(205, 0, 20, 1);
    }
  }
  .success-icon {
    display: inline-block;
    width: 22px;
    height: 22px;
    background: url("../../../assets/img/myPackage/option_select@2x.png")
      no-repeat center center;
    background-size: cover;
  }
  .scan-btn {
    width: 22px;
    height: 22px;
    background: url("../../../assets/img/myPackage/scan_icon@2x.png") no-repeat
      center center;
    background-size: cover;
  }
  .right-row {
    width: 22px;
    height: 22px;
    background: url("../../../assets/img/myPackage/arrow_grey_school.png")
      no-repeat center center;
    background-size: cover;
  }
  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    /* WebKit browsers */
    color: rgba(204, 204, 204, 1);
    opacity: 1;
    -webkit-text-fill-color: rgba(204, 204, 204, 1); //字体颜色安卓与IOS适配
    -webkit-opacity: 1; //不透明级别安卓与IOS适配
  }
  input:-moz-placeholder,
  textarea:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: rgba(204, 204, 204, 1);
    -webkit-text-fill-color: rgba(204, 204, 204, 1); //字体颜色安卓与IOS适配
    -webkit-opacity: 1; //不透明级别安卓与IOS适配
  }
  input::-moz-placeholder,
  textarea::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: rgba(204, 204, 204, 1);
    -webkit-text-fill-color: rgba(204, 204, 204, 1); //字体颜色安卓与IOS适配
    -webkit-opacity: 1; //不透明级别安卓与IOS适配
  }
  input:-ms-input-placeholder,
  textarea:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: rgba(204, 204, 204, 1);
    -webkit-text-fill-color: rgba(204, 204, 204, 1); //字体颜色安卓与IOS适配
    -webkit-opacity: 1; //不透明级别安卓与IOS适配
  }
}
</style>
